module.exports = __webpack_public_path__ + "static/media/Icons-Content-Calendar.adfdd516.svg";